export interface PhoneCountry {
    iso: string;
    name: string;
    flag: string;
    dialCode: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
    {iso: 'IT', name: 'Italia', flag: '🇮🇹', dialCode: '+39'},
    {iso: 'CH', name: 'Svizzera', flag: '🇨🇭', dialCode: '+41'},
    {iso: 'FR', name: 'Francia', flag: '🇫🇷', dialCode: '+33'},
    {iso: 'DE', name: 'Germania', flag: '🇩🇪', dialCode: '+49'},
    {iso: 'ES', name: 'Spagna', flag: '🇪🇸', dialCode: '+34'},
    {iso: 'AT', name: 'Austria', flag: '🇦🇹', dialCode: '+43'},
    {iso: 'BE', name: 'Belgio', flag: '🇧🇪', dialCode: '+32'},
    {iso: 'NL', name: 'Paesi Bassi', flag: '🇳🇱', dialCode: '+31'},
    {iso: 'PT', name: 'Portogallo', flag: '🇵🇹', dialCode: '+351'},
    {iso: 'GB', name: 'Regno Unito', flag: '🇬🇧', dialCode: '+44'},
    {iso: 'US', name: 'Stati Uniti', flag: '🇺🇸', dialCode: '+1'},
];
